import { useContext, useEffect, useState, useRef } from 'react';
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
import { Typography, Grid, GridList, GridListTile, GridListTileBar } from '@material-ui/core';
import Tr from '../shared/tr';

import galleryModel from '../model/GalleryModel';
import { AppContext } from '../App';

import DeleteIcon from '../../assets/image/toolbar/delete_light.svg';
import FullScreenIcon from '../../assets/image/toolbar/full_screen_light.svg';
import TooltipButton from '../shared/TooltipButton';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-around',
      overflow: 'hidden',
      height: '100%',
    },
    gridList: {
      width: '100%',
      height: '100%',
      alignContent: 'flex-start',
    },
    selected: {
      border: '2px solid #36B0C9',
      boxSizing: 'border-box',
      borderRadius: 4,
    },
    grid: {
      width: '100%',
      height: '90%',
      margin: '20px 20px 0 0 ',
    },
    titleBar: {
      background: 'linear-gradient(to bottom, rgba(0,0,0,0.7) 0%, ' + 'rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)',
    },
    btn: {
      width: 32,
      height: 32,
    },
    num: {
      minWidth: 32,
      height: 16,
      background: '#40C140',
      borderRadius: 16,
      color: 'white',
      textAlign: 'center',
      display: 'inline-block',
      paddingLeft: 5,
      paddingRight: 5,
    },
  })
);

function Gallery() {
  const classes = useStyles();
  const model = galleryModel;
  const [snapshots, setShapshots] = useState(null);
  const { galleryChanged, setGalleryChanged } = useContext(AppContext);
  const imgRefs = useRef(new Map());

  useEffect(() => {
    setShapshots(model.snapshots);
    if (model.snapshotsSize() <= 0) {
      imgRefs.current.clear();
    }
    if (imgRefs.current.has(selectedIndex)) {
      const ref = imgRefs.current.get(selectedIndex);
      ref.scrollIntoView({
        behavior: 'smooth',
        block: 'end',
        inline: 'nearest',
      });
    }
  }, [galleryChanged]);

  const tileData = snapshots ? snapshots : model.snapshots;
  const selectedIndex = model.previewSnapshotIndex;

  const selectClass = (index: number) => {
    return selectedIndex === index ? classes.selected : null;
  };

  const onDelete = (index: number) => {
    model.deleteSnapshot(index);
    setGalleryChanged((v) => !v);
  };

  const onFullScreen = (index: number) => {
    if (model.setSnapshotPreviewIndex(index)) {
      setGalleryChanged((v) => !v);
    }
  };
  const tr = new Tr();

  return (
    <div className={classes.root}>
      <Grid container spacing={2} alignItems="center" justify="center" className={classes.grid}>
        <Grid item container xs={12} alignItems="center">
          <Grid item xs={6}>
            <Typography gutterBottom variant="h5">
              <b>{tr.titlebarGallery()}</b>
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <label className={classes.num}>{model.snapshotsSize()}</label>
          </Grid>
        </Grid>
        <GridList cellHeight={100} className={classes.gridList} cols={3}>
          {tileData.map((tile, index) => (
            <GridListTile className={selectClass(index)} ref={(arg) => imgRefs.current.set(index, arg)} key={index}>
              <img
                src={tile}
                onClick={() => {
                  onFullScreen(index);
                }}
              />
              <GridListTileBar
                className={classes.titleBar}
                titlePosition="top"
                actionPosition="right"
                actionIcon={
                  <div>
                    <TooltipButton
                      className={classes.btn}
                      title={tr.galleryDelete()}
                      imgSrc={DeleteIcon}
                      onClick={() => onDelete(index)}
                    />
                    <TooltipButton
                      className={classes.btn}
                      title={tr.galleryFullScreen()}
                      imgSrc={FullScreenIcon}
                      onClick={() => onFullScreen(index)}
                    />
                  </div>
                }
              />
            </GridListTile>
          ))}
        </GridList>
      </Grid>
    </div>
  );
}

export default Gallery;
